// Source: app/scripts/controllers/login-mfa.js
Auction.controller('LoginMfaController', [
  '$scope',
  '$rootScope',
  '$location',
  '$cookieStore',
  '$filter',
  'UserService',
  'Auth',
  'Page',
  'toaster',
  'crudService',
  function ($scope, $rootScope, $location, $cookieStore, $filter, UserService, Auth, Page, toaster, crudService) {

    var userService = crudService('users', {
      checkPasswordExpiration: {
        method: 'GET',
        url: '/data/rest/users/check_password_expiration'
      }
    });

    $scope.mfaCode = '';
    $scope.attemptsRemaining = null;
    $scope.tempToken = $cookieStore.get('mfaTempToken');

    if (!$scope.tempToken) {
      $location.path('/login');
      return;
    }

    $scope.submitMfaOnEnter = function ($event) {
      if ($event.keyCode === 13 || $event.which === 13 || $event.key === 'Enter') {
        $event.preventDefault();
        $scope.verifyMfa();
      }
    };

    function completeLogin() {
      if (!$rootScope.system) {
        $rootScope.system = 'GENERAL';
      }

      Page.navigationBySystem({system: $rootScope.system}, function () {
        Auth.authenticate();

        if ($rootScope.returnPath && $rootScope.returnPath !== '/login' && $rootScope.returnPath !== '/login-mfa') {
          $location.path($rootScope.returnPath);
          delete $rootScope.returnPath;
        } else {
          userService.checkPasswordExpiration(function (isPasswordExpired) {
            if (isPasswordExpired.value === true) {
              localStorage.setItem('passwordExpiredMessage', $filter('translate')('Your password has expired. Please change it.'));
              $location.path('/user/profile');
            } else {
              $location.path('/');
            }
          }, function () {
            $location.path('/');
          });
        }
      });
    }

    $scope.verifyMfa = function () {
      UserService.verifyMfa($.param({
        tempToken: $scope.tempToken,
        code: $scope.mfaCode
      }), function (authenticationResult) {
        $cookieStore.remove('mfaTempToken');
        $rootScope.authToken = authenticationResult.token;
        $rootScope.loginAction = true;
        completeLogin();
      }, function (error) {
        var data = error.data || {};
        var messageKey = data._error || 'auth.mfa_invalid';

        if (data.tempToken) {
          $scope.tempToken = data.tempToken;
          $cookieStore.put('mfaTempToken', data.tempToken);
        }

        if (typeof data.attemptsRemaining === 'number') {
          $scope.attemptsRemaining = data.attemptsRemaining;
        }

        if (messageKey === 'auth.mfa_too_many_attempts') {
          $cookieStore.remove('mfaTempToken');
          toaster.pop('error', $filter('translate')('generic.error'),
            $filter('translate')(messageKey));
          $location.path('/login');
          return;
        }

        toaster.pop('error', $filter('translate')('generic.error'),
          $filter('translate')(messageKey));
        $scope.mfaCode = '';
      });
    };

    $scope.backToLogin = function () {
      $cookieStore.remove('mfaTempToken');
      $location.path('/login');
    };
  }
]);
